import { css, html, LitEntity } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './bin-profile-index';
import { StoreMixin } from '../../utility/store-mixin';

class BinLevelOnly extends StoreMixin(LitEntity) {
  static get styles() {
    return [sharedStyles, css`
      .bin-profile {
        width: 200px;
      }
    `];
  }

  static get properties() {
    return {
      publishedAt: { type: String, attribute: false },
    };
  }

  render() {
    return html`
      <bin-profile-index
        .href="${this.href}"
        class="bin-profile"
        disable-rotation
        published-at="${this.publishedAt || ''}"
      ></bin-profile-index>
    `;
  }

  async _stateChanged({ query }) {
    this.publishedAt = query.publishedAt;
  }
}

window.customElements.define('bin-level-only', BinLevelOnly);
